import React from 'react';
import { Link } from 'react-router-dom';

const NotFound: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full text-center">
        <div className="text-6xl font-bold text-orange-500 mb-4">۴۰۴</div>
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
          صفحه مورد نظر یافت نشد
        </h1>
        <p className="text-lg text-gray-600 dark:text-gray-300 mb-8">
          متأسفانه صفحه‌ای که به دنبال آن هستید وجود ندارد یا منتقل شده است.
        </p>
        
        <div className="space-y-4">
          <Link
            to="/"
            className="inline-block w-full px-6 py-3 bg-gradient-to-r from-orange-500 to-red-500 text-white font-semibold rounded-lg hover:from-orange-600 hover:to-red-600 transition-all duration-300"
          >
            بازگشت به صفحه اصلی
          </Link>
          
          <Link
            to="/dashboard"
            className="inline-block w-full px-6 py-3 border-2 border-orange-500 text-orange-500 dark:text-orange-400 font-semibold rounded-lg hover:bg-orange-50 dark:hover:bg-orange-900/20 transition-all duration-300"
          >
            رفتن به داشبورد
          </Link>
        </div>
        
        <div className="mt-8 text-sm text-gray-500 dark:text-gray-400">
          <p>یا می‌توانید از منوی اصلی استفاده کنید</p>
        </div>
      </div>
    </div>
  );
};

export default NotFound; 